// extracted by mini-css-extract-plugin
export default {"mCard":"LA-z","image":"MA-z","imageNoBackground":"NA-z","imageHasCategory":"OA-z","fullWidth":"PA-z"};